import { ReactNode } from "react";
import { Outlet, Link } from "react-router-dom";
import { Sidebar } from "./layout/Sidebar";
import { useSessionMonitor } from "@/hooks/useSessionMonitor";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { Rocket, ArrowRight } from "lucide-react";

interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  // Surveiller la session et rediriger si expirée
  useSessionMonitor();

  const { isFreeTrial, freeTrialDaysLeft } = useSubscription();

  return (
    <div className="min-h-screen bg-background flex">
      {/* Sidebar latérale */}
      <Sidebar />

      {/* Contenu principal - largeur maximale élargie */}
      <main className="flex-1 overflow-y-auto">
        {/* Banner free trial */}
        {isFreeTrial && (
          <div className="bg-gradient-to-r from-blue-600 to-amber-500 text-white px-4 py-3">
            <div className="max-w-screen-2xl mx-auto flex items-center justify-between gap-4 flex-wrap">
              <div className="flex items-center gap-2 text-sm font-medium">
                <Rocket className="h-4 w-4 flex-shrink-0" />
                <span>
                  Essai gratuit Pro — Il vous reste <strong>{freeTrialDaysLeft} jour{freeTrialDaysLeft > 1 ? 's' : ''}</strong>
                </span>
              </div>
              <Link
                to="/payment-setup?choose=true"
                className="inline-flex items-center gap-1.5 bg-white text-blue-700 font-bold text-sm px-4 py-1.5 rounded-full hover:bg-blue-50 transition-colors"
              >
                Choisissez votre plan
                <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            </div>
          </div>
        )}

        <div className="max-w-screen-2xl mx-auto px-4 py-8 md:px-6 lg:px-8 xl:px-12">
          {children || <Outlet />}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
